export default "__VITE_ASSET__CjWxIuFD__"